import React, { useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { ProduccionReportadaApi } from "../api/ProduccionReportadaApi";
import Paginacion from "../../../../../../Utils/Components/Paginacion/Paginacion";
import LoadMask from "../../../../../../Utils/LoadMask/LoadMask";
import { ProdReportadasTable } from "./ProdReportadasTable";
import { useDebounce } from "../../../../../../Utils/Hooks/useDebounce";
import { getErrorFromResponse } from "../../../../../../../../utility/utils";
import { ProduccionAnterior } from "./ProduccionAnterior";
import { ProdReportadaForm } from "./ProdReportadaForm";
import { TotalProduccion } from "./TotalProduccion";
import { DecisionSwal } from "../../../../../../Utils/Utils/DecisionSwal";
import { BadgeReabrirPaletizacion } from "../../../components/BadgeReabrirPaletizacion/BadgeReabrirPaletizacion";

export const Listado = ({
    regresar,
    navigateToPaletizaciones,
    navigateToCierreTurno,
}) => {
    const [produccionesReportadas, setProduccionesReportadas] = useState([]);
    const [produccionAnterior, setProduccionAnterior] = useState({});
    const [totalesProduccion, setTotalesProduccion] = useState(0);
    const [paletizacionCerrada, setPaletizacionCerrada] = useState(false);

    const { getProduccionTurno, deleteEnvio, cargando } =
        ProduccionReportadaApi();

    const GetProduccionActual = async () => {
        try {
            const response = await getProduccionTurno();
            if (response) {
                setProduccionesReportadas(
                    response.producciones_reportadas || [],
                );

                if (response.turno_anterior) {
                    setProduccionAnterior({
                        pesoPacasSecadoraProyectadas:
                            response.turno_anterior
                                .peso_pacas_secadora_proyectadas || 0,
                        pesoPacasReportadas:
                            response.turno_anterior.peso_pacas_reportadas || 0,
                        productoPacasSecadoraNombre:
                            response.turno_anterior
                                .producto_pacas_secadora_nombre || null,
                        productosReportados:
                            response.turno_anterior.productos_reportados || [],
                    });
                } else setProduccionAnterior({});

                if (response.totales_produccion) {
                    setTotalesProduccion({
                        cantidadPacas:
                            response.totales_produccion.cantidad_pacas || 0,
                        kgSecosPacas:
                            response.totales_produccion.kg_secos_pacas || 0,
                    });
                } else setTotalesProduccion({});

                if (response.turno_actual) {
                    setPaletizacionCerrada(
                        response.turno_actual.paletizacion_cerrada,
                    );
                } else setPaletizacionCerrada(false);
            }
        } catch (error) {
            console.log("Error al obtener producciones reportadas:", error);
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener las producciones reportadas",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setProduccionesReportadas([]);
            setProduccionAnterior({});
            setTotalesProduccion({});
            setPaletizacionCerrada(false);
        }
    };

    useEffect(() => {
        GetProduccionActual();
    }, []);

    const EliminarEntrega = async (id) => {
        try {
            await deleteEnvio(id);
            NotificationManager.success(
                "Envío eliminado correctamente",
                "Éxito",
                3000,
            );
            GetProduccionActual();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al eliminar envío",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const IrACierreTurno = () => {
        if (!paletizacionCerrada) {
            DecisionSwal(
                "La paletización no ha sido cerrada.",
                "Ir a paletización",
                "Cancelar",
                () => navigateToPaletizaciones(),
            );
        } else {
            navigateToCierreTurno();
        }
    };

    return (
        <div className="prod-reportada__tab-wrapper">
            <LoadMask loading={cargando} blur>
                <CardEmpty noShadow>
                    <ProduccionAnterior
                        produccionAnterior={produccionAnterior}
                    />

                    {!paletizacionCerrada ? (
                        <ProdReportadaForm
                            GetProduccionActual={GetProduccionActual}
                        />
                    ) : (
                        <div className="d-flex justify-content-center mb-3">
                            <BadgeReabrirPaletizacion
                                onReabierta={GetProduccionActual}
                            />
                        </div>
                    )}

                    <ProdReportadasTable
                        produccionesReportadas={produccionesReportadas}
                        EliminarEntrega={EliminarEntrega}
                        paletizacionCerrada={paletizacionCerrada}
                    />

                    <TotalProduccion totalesProduccion={totalesProduccion} />

                    <div className="d-flex mt-3 mb-3 align-items-center gap-1rem">
                        <div className="d-flex gap-1rem flex-1"></div>
                        <div className="d-flex gap-1rem flex-1 justify-content-center">
                            <button
                                className="btn btn-outline-dark"
                                onClick={regresar}
                            >
                                Regresar
                            </button>
                        </div>

                        <div className="d-flex gap-1rem flex-1 justify-content-end">
                            <Link to="/produccion-v2/paletizaciones">
                                <button className="btn btn-outline-info">
                                    Paletización
                                </button>
                            </Link>
                            <button
                                className="btn btn-secondary"
                                onClick={IrACierreTurno}
                            >
                                Cerrar turno
                            </button>
                        </div>
                    </div>
                </CardEmpty>
            </LoadMask>
        </div>
    );
};
